document.addEventListener('DOMContentLoaded', function() {
  accordion();
});

function accordion() {
  document.querySelectorAll('.div-faq').forEach(main => {
    main.querySelectorAll('.div-faq-item').forEach(item => {
      const question = item.querySelector('.div-faq-question');

      question.addEventListener('click', () => {
        const isOpen = item.classList.contains('active');

        // Close all
        document.querySelectorAll('.div-faq-item.active').forEach(openItem => {
          openItem.classList.remove('active');
        });

        // Toggle current
        if (!isOpen) {
          item.classList.add('active');
        }
      });
    });
    // Open first item by default
    const firstItem = document.querySelector('.div-faq-item');
    if (firstItem) {
      firstItem.classList.add('active');
    }
  });
}